"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Telegraph Public API
 * Public API offering access to Telegraph data
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: bookingsupport@telegraph.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionSetLineNumberLXLoopToJSON = exports.TransactionSetLineNumberLXLoopFromJSONTyped = exports.TransactionSetLineNumberLXLoopFromJSON = exports.instanceOfTransactionSetLineNumberLXLoop = void 0;
var DescriptionMarksAndNumbersL5_1 = require("./DescriptionMarksAndNumbersL5");
var ExportLicenseX1_1 = require("./ExportLicenseX1");
var LineItemQuantityAndWeightL0Loop_1 = require("./LineItemQuantityAndWeightL0Loop");
var TransactionSetLineNumberLX_1 = require("./TransactionSetLineNumberLX");
/**
 * Check if a given object implements the TransactionSetLineNumberLXLoop interface.
 */
function instanceOfTransactionSetLineNumberLXLoop(value) {
    return true;
}
exports.instanceOfTransactionSetLineNumberLXLoop = instanceOfTransactionSetLineNumberLXLoop;
function TransactionSetLineNumberLXLoopFromJSON(json) {
    return TransactionSetLineNumberLXLoopFromJSONTyped(json, false);
}
exports.TransactionSetLineNumberLXLoopFromJSON = TransactionSetLineNumberLXLoopFromJSON;
function TransactionSetLineNumberLXLoopFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'transaction_set_line_number_LX': json['transaction_set_line_number_LX'] == null ? undefined : (0, TransactionSetLineNumberLX_1.TransactionSetLineNumberLXFromJSON)(json['transaction_set_line_number_LX']),
        'description_marks_and_numbers_L5': json['description_marks_and_numbers_L5'] == null ? undefined : (json['description_marks_and_numbers_L5'].map(DescriptionMarksAndNumbersL5_1.DescriptionMarksAndNumbersL5FromJSON)),
        'line_item_quantity_and_weight_L0_loop': json['line_item_quantity_and_weight_L0_loop'] == null ? undefined : (json['line_item_quantity_and_weight_L0_loop'].map(LineItemQuantityAndWeightL0Loop_1.LineItemQuantityAndWeightL0LoopFromJSON)),
        'export_license_X1': json['export_license_X1'] == null ? undefined : (json['export_license_X1'].map(ExportLicenseX1_1.ExportLicenseX1FromJSON)),
    };
}
exports.TransactionSetLineNumberLXLoopFromJSONTyped = TransactionSetLineNumberLXLoopFromJSONTyped;
function TransactionSetLineNumberLXLoopToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'transaction_set_line_number_LX': (0, TransactionSetLineNumberLX_1.TransactionSetLineNumberLXToJSON)(value['transaction_set_line_number_LX']),
        'description_marks_and_numbers_L5': value['description_marks_and_numbers_L5'] == null ? undefined : (value['description_marks_and_numbers_L5'].map(DescriptionMarksAndNumbersL5_1.DescriptionMarksAndNumbersL5ToJSON)),
        'line_item_quantity_and_weight_L0_loop': value['line_item_quantity_and_weight_L0_loop'] == null ? undefined : (value['line_item_quantity_and_weight_L0_loop'].map(LineItemQuantityAndWeightL0Loop_1.LineItemQuantityAndWeightL0LoopToJSON)),
        'export_license_X1': value['export_license_X1'] == null ? undefined : (value['export_license_X1'].map(ExportLicenseX1_1.ExportLicenseX1ToJSON)),
    };
}
exports.TransactionSetLineNumberLXLoopToJSON = TransactionSetLineNumberLXLoopToJSON;
